import { useEffect, useRef, useState } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import './Listing.css';
import Productcard from '../../Components/Productcard/Productcard';
import Cartstrip from '../../Components/Cartstrip/Cartstrip';

function Listing() {
    const [allpro, setAllpro] = useState([]);
    const [pagination, setPagination] = useState({});
    const [loading, setLoading] = useState(false);

    const categoryFilterRef = useRef(null);

    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    const page = parseInt(searchParams.get("page") || 1);
    const category = searchParams.get("category") || "all";
    const limit = 20; // fixed limit

    // Fetch products whenever page or category changes
    useEffect(() => {
        setLoading(true);
        fetch(`https://pentadeco.in/api/products/${page}/${limit}/${category}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setAllpro(data.products);
                    setPagination(data.pagination);
                }
                setLoading(false);
            })
            .catch(err => {
                console.log('Error fetching products:', err);
                setLoading(false);
            });
    }, [page, category]);

    // Handler to change page
    const handlePageChange = (newPage) => {
        searchParams.set("page", newPage);
        setSearchParams(searchParams);
    }

    // Handler to change category
    const handleCategoryChange = (cat) => {
        searchParams.set("category", cat);
        searchParams.set("page", 1); // reset page on category change
        setSearchParams(searchParams);
    }

    const catimgs = [
        "/assets/categories/547A4158.JPG",
        "/assets/categories/547A9024.JPG",
        "/assets/categories/547A4904.JPG",
        "/assets/categories/IMG_3112.JPG",
        "/assets/categories/547A4378.JPG",
        "/assets/categories/547A9131.JPG",
        "/assets/categories/547A4304.JPG",
        "/assets/categories/547A4253.JPG",
        "/assets/categories/547A9113.JPG",
        "/assets/categories/547A9068.JPG",
        "/assets/categories/547A4555.JPG",
        "/assets/categories/547A4297.JPG",
        "/assets/categories/547A4868.JPG",
        "/assets/categories/547A4247.JPG",
        "/assets/categories/IMG_3067.JPG",
        "/assets/categories/547a8909.JPG"
    ];

    const handleScrollRight = () => {
        if (categoryFilterRef.current) {
            categoryFilterRef.current.scrollBy({ left: 320, behavior: "smooth" });
        }
    };

    return (
        <div className='main-lising pb-5 mb-5'>
            <div className="container mt-4 pt-0">
                <div className="product-n-filter">

                    <div className="d-flex flex-wrap align-items-center justify-content-between mb-3 position-relative">
                        <div ref={categoryFilterRef} className="categoryFilter d-flex mb-3">
                            {[
                                "all",
                                "capsule mug",
                                "inside colour mug",
                                "Magic Mug",
                                "White Mug",
                                "Bag Tag",
                                "Mouse Pad",
                                "Coasters",
                                "Coke Bottle",
                                "Sipper Water Bottle (600ml)",
                                "Sipper Water Bottle (750ml)",
                                "Sports Water Bottle",
                                "Set of 2 Cups",
                                "Frosted Glass Jar",
                                "Money Bank",
                                "Wall Decor",
                                "hand bags"
                            ].map((cat, i) => (
                                <button
                                    key={i}
                                    className={`nav-link mb-0 p-1 d-flex align-items-center rounded-3 text-nowrap lh-sm fs-sm me-2 ${category === cat.toLowerCase() ? 'bg-brand-secondary text-white border-brand-secondary' : 'border'}`}
                                    onClick={() => handleCategoryChange(cat.toLowerCase())}
                                >
                                    {cat !== 'all' && <img src={catimgs[i-1]} alt="cat icon" width={30} className='me-2 rounded-1' style={{aspectRatio: '1/1', objectFit: 'cover'}} />}{cat.replace(/-/g, " ").replace(/\b\w/g, l => l.toUpperCase())}
                                </button>
                            ))}
                            <p className="bg-white px-2"></p>
                            <p className="mb-0 py-2 bg-white fiter-right cursor-pointer" onClick={() => handleScrollRight()}><i className="fi fi-ss-angle-right"></i></p>
                        </div>
                        {/* <div className="sortFilter mb-3">
                            <select name="sort" id="sort" className='form-select rounded-3 shadow-none fs-sm'>
                                <option value="">Sort</option>
                                <option value="lowest-to-highest">Lowest to Highest</option>
                                <option value="highest-to-lowest">Highest to Lowest</option>
                            </select>
                        </div> */}
                    </div>
                    
                    <div className="main-listing">
                        {loading ? (
                            <p>Loading products...</p>
                        ) : (
                            <div className="row">
                                {allpro?.length > 0 ? allpro.map((pro, ind) => (
                                    <div key={ind} className="col-md-3 col-6 p-1">
                                        <Productcard 
                                            coverimg={pro.images[0]} 
                                            tag={pro.status} 
                                            category={pro.category} 
                                            saletxt={pro.spinningtxt} 
                                            name={pro.name} 
                                            price={pro.discountprice} 
                                            preprice={pro.price} 
                                            id={pro.proid} 
                                        />
                                    </div>
                                )) : (
                                    <p className="text-center">No products found</p>
                                )}
                            </div>
                        )}

                        {/* Pagination */}
                        {pagination.totalPages > 1 && (
                            <div className="d-flex justify-content-center mt-4">
                                <button
                                    className="btn btn-brand-secondary me-2"
                                    disabled={!pagination.isPrevious}
                                    onClick={() => handlePageChange(pagination.prevPage)}
                                >
                                    <i className="fi fi-ss-angle-left" style={{position: "relative", bottom: '-3px'}}></i>
                                </button>
                                <span className="px-3 align-self-center">Page {pagination.currentPage} of {pagination.totalPages}</span>
                                <button
                                    className="btn btn-brand-secondary ms-2"
                                    disabled={!pagination.isNext}
                                    onClick={() => handlePageChange(pagination.nextPage)}
                                >
                                    <i className="fi fi-ss-angle-right" style={{position: "relative", bottom: '-3px'}}></i>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Cartstrip/>

        </div>
    )
}

export default Listing;
